import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from 'react-router';
import { useUnsavedChanges } from '@connect-x-app/hybrid-state';
import { APP_TEST_IDS } from '@connect-x-app/web-test-ids';
import { ConfirmationModal } from '@connect-x-app/web-ui';

export const NavigationGuard = () => {
  const { t } = useTranslation();
  const { hasUnsavedChanges, setHasUnsavedChanges } = useUnsavedChanges();

  const blocker = useBlocker(hasUnsavedChanges);

  const showModal = useMemo(() => {
    return blocker.state === 'blocked';
  }, [blocker.state]);

  const confirmNavigation = async () => {
    await setHasUnsavedChanges(false);
    blocker.proceed?.();
  };

  const cancelNavigation = () => {
    blocker.reset?.();
  };

  return (
    <>
      {showModal ? (
        <ConfirmationModal
          confirmText={t('NAVIGATION_GUARD.CONFIRM')}
          content={t('NAVIGATION_GUARD.CONTENT')}
          onCancel={cancelNavigation}
          onConfirm={confirmNavigation}
          testId={APP_TEST_IDS.navigationGuard.modal}
          title={t('NAVIGATION_GUARD.TITLE')}
        />
      ) : null}
    </>
  );
};
